var map = {
	"./arcade.png": 8478,
	"./chat.png": 604,
	"./events.png": 7073,
	"./fish.png": 4752,
	"./gameRecords.png": 6248,
	"./hot.png": 6293,
	"./poker.png": 9131,
	"./records.png": 3154,
	"./redeem.png": 4574,
	"./security.png": 6996,
	"./settings.png": 1961,
	"./slot.png": 2966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5849;